<template>
  <form
    class="d-flex-column justify-start align-start"
    style="margin-top: 60px"
    @submit.prevent="createContactRequest"
  >
    <h3 class="t-white title-h3 f-w-600 font-family-1">
      {{ $t("contact.lets_talk") }}
    </h3>
    <p class="t-light font-family-2 regular-xxl">
      {{ $t("contact.lets_talk_desc") }}
    </p>

    <div class="d-flex-column justify-start align-start gap-30">
      <div
        class="d-flex-row md-row-to-col space-between gap-24"
        style="margin-top: 20px"
      >
        <InputField variant="medium" placeholder="Name" v-model="params.name" />
        <InputField
          variant="medium"
          placeholder="Email"
          v-model="params.email"
        />
      </div>
      <TextArea placeholder="Message" v-model="params.message" />

      <button
        class="primary filled max-width-213px full-width xl height-48 b-radius-9 regular-l f-w-600 font-family-1"
        type="submit"
        :disabled="
          !params.token || !params.email || !params.name || !params.message
        "
        :class="[loading && 'loading']"
      >
        {{ $t("contact.send") }}
      </button>

      <NuxtTurnstile
        v-model="params.token"
        :site-key="publicConfig.turnstileSiteKey"
      />
    </div>
  </form>
</template>

<script setup>
import InputField from "../custom/InputField.vue";
import TextArea from "../custom/TextArea.vue";
import { ref } from "vue";

// HOOKS
const { public: publicConfig } = useRuntimeConfig();
const { setSnack } = useGenericStore();
// REACTIVITY
const params = ref({
  name: "",
  email: "",
  message: "",
  token: "",
});

const loading = ref(false);

const createContactRequest = async () => {
  try {
    loading.value = true;
    const { data: response } = await useApiPost("/api/create-contact-request", {
      method: "POST",
      body: {
        locale: getLocale(),
        ...params.value,
      },
    });
    loading.value = false;
    if (response.message_title) {
      setSnack({
        title: response.message_title,
        status: response.message_status,
        description: response.message,
        showProgress: true,
        position: "top-right",
        type: response.message_status,
        timeout: 5000,
      });
    }
    params.value = {
      name: "",
      email: "",
      message: "",
    };
  } catch (error) {
    loading.value = false;
    console.log(error);
  }
};
</script>
